import { createApp, h } from 'vue';
/**
 * Experimental function to create a modal
 *
 */
function createModalApp(component, props, close) {
    return createApp({
        render() {
            return h(component, Object.assign({ modelValue: true, onClose: close, 'onUpdate:modelValue': () => {
                    close();
                } }, props));
        },
    });
}
export function useModal(appContext, component, props) {
    let app = null;
    let container = null;
    const close = () => {
        app === null || app === void 0 ? void 0 : app.unmount();
        if (container) {
            document.body.removeChild(container);
        }
    };
    function show() {
        container = document.createElement('div');
        document.body.appendChild(container);
        app = createModalApp(component, props, close);
        Object.assign(app._context, appContext);
        if (container instanceof HTMLDivElement) {
            app === null || app === void 0 ? void 0 : app.mount(container);
        }
    }
    return { show, close };
}
